"use client";

import React from "react";
const markets = [{
  region: "UNITED STATES",
  value: "6.78",
  suffix: "%",
  description: "$208B → $308B market expansion by 2030. Supported by enterprise AI adoption and hyperscale expansion. N2N's U.S. strategy is anchored by a six-asset brownfield portfolio with investment-grade tenancy and immediate cash yield. Transaction multiples for stabilized AI assets are currently trading at 25x EBITDA — a significant premium to traditional commercial real estate.",
  footer: "CAGR 2024–2030"
}, {
  region: "INDIA",
  value: "13.37",
  suffix: "%",
  description: "13%+ CAGR through 2033. Energy-secured AI campuses driving new development cycles. Structural demand for sovereign and hyperscaler AI compute at scale. N2N targets energy-secured sites with long-term PPA infrastructure and proximity to fiber corridors.",
  footer: "CAGR 2025–2033"
}, {
  region: "LATIN AMERICA",
  value: "12.2",
  suffix: "%",
  description: "Mexico is emerging as the anchor of U.S. hyperscaler expansion into LATAM, with N2N positioned to deliver the first certified GB300 Neo Cloud platform in the region. The LATAM market is growing at 12%+ CAGR through 2030, with Mexico specifically benefiting from nearshore data sovereignty trends and U.S. digital corridor adjacency.",
  footer: "CAGR 2024–2030"
}];
export default function MarketOpportunitySection() {
  return <section id="market-opportunity" className="relative overflow-hidden bg-background text-foreground">
      <div className="absolute inset-0 opacity-[0.04] [background-image:radial-gradient(circle_at_20%_20%,rgba(28,25,23,0.06),transparent_35%),radial-gradient(circle_at_80%_30%,rgba(28,25,23,0.03),transparent_30%),linear-gradient(to_right,rgba(28,25,23,0.015)_1px,transparent_1px),linear-gradient(to_bottom,rgba(28,25,23,0.015)_1px,transparent_1px)] [background-size:auto,auto,48px_48px,48px_48px]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(180,83,9,0.05),transparent_28%),radial-gradient(circle_at_bottom_right,rgba(180,83,9,0.03),transparent_24%)]" />

      <div className="relative mx-auto max-w-[1600px] px-6 py-20 md:px-10 md:py-24 xl:px-14">
        <div className="mb-12 flex items-center gap-4">
          <span className="h-px w-9 bg-accent" />
          <span className="font-mono text-[11px] uppercase tracking-[0.38em] text-accent">
            Market Opportunity
          </span>
        </div>

        <div className="mb-14 grid gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:items-start xl:mb-16">
          <div className="max-w-[900px]">
            <h2 className="font-serif text-[40px] leading-[0.98] tracking-[-0.04em] text-foreground md:text-[56px] lg:text-[65px]">
              Concentrated Exposure
              <br />
              to the{" "}
              <span className="italic text-accent">
                Three Highest-Growth AI Markets Globally
              </span>
            </h2>
          </div>

          <div className="max-w-[760px] pt-2 lg:justify-self-end">
            <p className="text-[1.15rem] leading-[1.8] text-foreground/70 md:text-[1.35rem]">A $7T+ infrastructure cycle is underway. Hyperscalers are allocating ~$1 trillion toward digital infrastructure between 2026 and 2030. N2N Capital's investment is concentrated in the three highest-growth markets globally.</p>
          </div>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {markets.map((market, i) => <article key={market.region} data-index={i} className="group flex min-h-[360px] flex-col border border-accent/10 bg-card p-8 transition-colors duration-300 hover:border-accent/40">
              <div className="mb-8 font-mono text-[11px] uppercase tracking-[0.38em] text-accent">
                {market.region}
              </div>

              <div className="mb-8 flex items-end gap-1 text-foreground">
                <span className="font-serif text-[2.8rem] leading-none tracking-[-0.03em] md:text-[3.5rem]">
                  {market.value}
                </span>
                <span className="mb-1 font-serif text-[1.4rem] italic leading-none text-accent md:text-[1.8rem]">
                  {market.suffix}
                </span>
              </div>

              <p className="max-w-[34rem] text-[1.02rem] leading-[1.95] text-foreground/70 md:text-[1.08rem]">
                {market.description}
              </p>

              <div className="mt-auto pt-10 text-right font-mono text-[11px] uppercase tracking-[0.3em] text-accent">
                {market.footer}
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}